import "./ThemeMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { themeIcons } from "./themeIcons";

export default function ThemeMenu({
    themes,
    currentTheme,
    onSelect,
    onClose
}) {

      const sortedThemes = [...themes].sort((a, b) =>
    a.nom.localeCompare(b.nom, "fr", {
        sensitivity: "base",
    })
);

    return (
        <div
            className="theme-menu"
            onClick={(e) => e.stopPropagation()}
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: "8px",
                width: "540px",
                maxWidth: "calc(100vw - 32px)",
                padding: "10px"
            }}
        >
            {sortedThemes.map((theme) => (
                <div
                    key={theme.id}
                    className={`theme-item ${currentTheme === theme.id ? "selected" : ""}`}
                    onClick={() => {
                        onSelect(theme.id);
                        onClose();
                    }}
                    style={{
                        minWidth: 0
                    }}
                >
                    <span className="theme-check">
                        {currentTheme === theme.id ? "✓" : ""}
                    </span>

                    <span className="theme-icon">
                        <FontAwesomeIcon
                            icon={themeIcons[theme.icon]}
                        />
                    </span>

                    <span className="theme-name">
                        {theme.nom}
                    </span>
                </div>
            ))}

            <div
                className="theme-separator"
                style={{ gridColumn: "1 / -1" }}
            ></div>

            <div
                className="theme-item"
                onClick={() => {
                    onSelect(null);
                    onClose();
                }}
                style={{ gridColumn: "1 / -1" }}
            >
                <span className="theme-check">
                    {currentTheme === null ? "✓" : ""}
                </span>

                <span className="theme-icon">
                    ✕
                </span>

                <span className="theme-name">
                    Aucun thème
                </span>
            </div>
        </div>
    );
}
